export const getDataState = (
  isActive: boolean,
  isDesc?: boolean,
): string | undefined => {
  if (!isActive) return undefined;
  return isDesc ? 'active-desc' : 'active-asc';
};
